import script from "./NosotrosMobile.vue?vue&type=script&lang=js"
export * from "./NosotrosMobile.vue?vue&type=script&lang=js"

import "./NosotrosMobile.vue?vue&type=style&index=0&id=3941a9dc&lang=css"

const __exports__ = script;

export default __exports__